import { getDurationPresetRange, type DurationPreset } from '../dashboard/utils/dateHelpers';

/** Resolves KPI duration filter to API / export date range (same shape as Bandwidth). */
export function getKpiExportDateRange(filterValues: Record<string, string | string[]>): {
  dateFrom: string;
  dateTo: string;
} {
  const timeRange = (filterValues.duration as string) || '';
  let dateFrom = '';
  let dateTo = '';

  if (timeRange.startsWith('custom:')) {
    const [, dates] = timeRange.split('custom:');
    const [from, to] = (dates || '').split(',');
    dateFrom = from || '';
    dateTo = to || '';
  } else if (timeRange.startsWith('preset:')) {
    const presetName = timeRange.replace('preset:', '') as DurationPreset;
    const range = getDurationPresetRange(presetName);
    dateFrom = range.from;
    dateTo = range.to;
  }

  return { dateFrom, dateTo };
}
